import { render, staticRenderFns } from "./SidebarFilterMaterialType.vue?vue&type=template&id=70eae48e&scoped=true&"
import script from "./SidebarFilterMaterialType.vue?vue&type=script&lang=js&"
export * from "./SidebarFilterMaterialType.vue?vue&type=script&lang=js&"
import style0 from "./SidebarFilterMaterialType.vue?vue&type=style&index=0&id=70eae48e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70eae48e",
  null
  
)

export default component.exports